const { cELM, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
const Chat = require("../chat");

class MedicationModule {
  constructor(type, value) {
    this.type = type;
    this.value = value;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `component-block module_meds_eng ${cssVariableKey}`);
    this.contentHash = {};
    this.typingIndicator = null;

    this.elContainer.addELM(new Provider({ data: value }));

    this._medicationBlock = this.drawIntro(
      value.values.medication ? value.values.medication.meds : [],
      value.values.day
    );

    this.elContainer.addELM(this._medicationBlock);

    this.edit = cELM("div", "button edit edit-active", 'Edit');
    this.edit.onclick = () => this.onEditClicked(this.value, this._medicationBlock);
    this.divider = cELM("div", "edit-wrapper");
    this.divider.addELM(this.edit)
    
    this._element = null;

    this.step = 0;
    if (!value.values.medication) {
      this.step = 1;
    }
    this.handle(type, value);
  }

  drawIntro(medications,dayText) {
    const medicationsBl = cELM("div", "medications");

    let html = "";
    let day = dayText || "day";
    
    const values = Object.values(medications);
    for (let midx = 0; midx < values.length; midx++) {
      const medication = values[midx];
      html += '<div class="med">';
      html += `<div class="name" title="${medication.name}">${medication.name}</div>`;
      html += `<div class="dosage" title="${medication.dosage}">${medication.dosage}</div>`;
      html += `<div class="frequency">${
        medication.timesPerDay ? `${medication.timesPerDay}/${day}` : ""
      }</div>`;
      html += "</div>";
    }

    medicationsBl.innerHTML = html;
  
    return medicationsBl;
  }

  handle(type, value, reference) {
    const _self = this;
    window.__FN_DATA_WRAPPER = function(txt) {
      if (_self.step === 1) {
        return { moreMeds: txt };
      } else if (_self.step === 2) {
        return {
          reference: "medication",
          typing: txt.toUpperCase(),
        };
      }

      return {
        content: txt,
        meta: value.values.lastentered,
      };
    };

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }
    
    const _elm = this.handleOnMessage(value);
    if (!_elm) return;

    if (this.step == 0 && this.lastEnteredExists(value)) {
      this.elContainer.addELM(this.divider);
      this.divider.style.display ='';
    } else {
      this.divider.style.display ='none';
    }

    this.elContainer.addELM(_elm);
   
    setTimeout(() => {
      _elm.focus();
    }, 400);

    if (this.value.continue === undefined || this.value.continue !== false) {
      this.step = (this.step + 1) % 4;
    }
  }

  handleOnMessage(value) {
    const _self = this;
    
    if (!value.values)
        return null
    let component = null;

    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    const values = value.values.medication || value.values;
    const messages = this.value.values.messages;

    if (value.continue === false) {
      this._element._option._element.updateSuggestions(values.suggestions);
      return;
    }

    if (this._element) {
      this.elContainer.removeELM(this._element);
      this.typingIndicator = null;
    }

    if (value.values.meds) {
      this.elContainer.removeELM(this._medicationBlock);
      this._medicationBlock = this.drawIntro(value.values.meds,value.values.day);
      this.elContainer.addELM(this._medicationBlock);
    }

    if (this.step === 0) {
      component = new Block({
        data: {
          id: (_self.value || {}).id,
          format: "yes/no",
          answer: "yes/no",
          text: messages.more.question,
          values: messages.more.values,
          onAnswer: val => {
            if (val && val.toLowerCase() === "no") {
              component.getELM().style.display = "none";
              this.divider.style.display = "none";
            }
          },
        },
      });
    } else if (this.step === 1) {
      component = new Block({
        data: {
          id: (_self.value || {}).id,
          format: "autocomplete",
          answer: "autocomplete",
          text: messages.intro.question,
          values: messages.intro.values,
        },
      });
    } else if (this.step === 2) {
      component = new Block({
        data: {
          id: (_self.value || {}).id,
          format: "singleselect-other",
          answer: "singleselect-other",
          text: values.messages.dosage.text,
          subtext: values.messages.dosage.subtext,
          values: values.lastentered.dosages,
        },
      });
    } else if (this.step === 3) {
      component = new Block({
        data: {
          id: (_self.value || {}).id,
          format: "singleselect-other",
          answer: "singleselect-other",
          text: values.messages.days.text,
          values: messages.days.values,
        },
      });
    }

    if (value.status === "typing" || value.id.indexOf("/") === -1) {
      this.typingIndicator = component;
    }

    this._element = component;
    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  scrollToFirstItem() {
    Scroller.scrollToElm(this);
  }

  onEditClicked(value, parentEl) {
    const self = this;
    confirmPop(
      {
        title: "Edit answer?",
        content: "This will delete the last medication.",
      },
      function(isConfirmed) {
        if (isConfirmed) {
          const optionEl = parentEl.lastChild;
          self.animateHideRemove(optionEl);
          Chat.default.edit({ id: value.id+'/answer'});
          self._element && self._element.reset && self._element.reset();
        } else {
        }
      },
    );
  }

  focus() {
    if (this._element) {
      this._element.focus();
    }
  }

  animateHideRemove(el) {
    el.style.display = "none";
    this.divider.style.display = "none";
  }
  
  lastEnteredExists(value) {
     let meds =  ((value.values || {}).meds)  ||  ((value.values || {}).medication || {}).meds || {};
     let last =   ((value.values || {}).lastentered)  ||  ((value.values || {}).medication || {}).lastentered;
     if (last && last.medication) {
       return Object.keys(meds).includes(last.medication)
     } else 
       return false
  }
}

module.exports = MedicationModule;
